import { useGetUserAccounts } from 'Features/AccountSelector/api/getUserAccounts'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { useMemo } from 'react'
import { useIsFirstLogin } from './useIsFirstLogin'
import { useGetAccountMetadata } from 'Features/ClickceaseMigrationBanner/api/useGetAccountMetadata'

export const useMigrationDisplay = () => {
  const { accountId } = useUserStore()
  const { isFirstLogin } = useIsFirstLogin()
  const { data: userAccountsData } = useGetUserAccounts()

  const isMigratedAccount = useMemo(
    () =>
      !!(
        userAccountsData &&
        userAccountsData.accounts.find((account) => account.accountId === accountId)?.migrated
      ),
    [accountId, userAccountsData]
  )

  const { data: accountMetadata } = useGetAccountMetadata(isMigratedAccount)

  return {
    isMigratedAccount,
    isFirstMigrationLogin: isMigratedAccount && isFirstLogin,
    isMigrationFinished: !!accountMetadata?.planAccepted,
  }
}
